<template>
    <b-modal ref="shareModal" hide-footer centered @close="btnSfx" :title="$t('share.popup_title') ">
        <div class="form-group form-group d-flex flex-wrap justify-content-center">
            <ShareNetwork v-for="s in settings" :key="s.network"
                :network="s.network"
                :url="$t('share.popup_data_url')"
                :title="$t('share.popup_data_title')"
                :description="$t('share.popup_data_description', { username: user.username })"
                :hashtags="$t('share.popup_data_hashtags')"
              >
                <i :class="s.icon"></i>
                <span>{{ $t('share.popup_option_'+s.network) }}</span>
            </ShareNetwork>
        </div>
        <div class="d-flex">
            <b-button @click="hide();btnSfx();" type="button" variant="primary" size="lg" class="m-auto w-auto pl-4 pr-4" >{{ $t('base.btn_cancel') }}</b-button>
        </div>
    </b-modal>
</template>
<script>
import Vue from 'vue'
import api from '../api'

const SharePopup = Vue.component('share-popup', {
    data() {
        return {
            settings: [
                { network: "facebook", icon: "fab fah fa-lg fa-facebook-f"},
                { network: "twitter", icon: "fab fah fa-lg fa-twitter"},
                { network: "email", icon: "far fah fa-lg fa-envelope"},
                { network: "skype", icon: "fab fah fa-lg fa-skype"},
                { network: "linkedin", icon: "fab fah fa-lg fa-linkedin"},
                { network: "whatsapp", icon: "fab fah fa-lg fa-whatsapp"},
                { network: "telegram", icon: "fab fah fa-lg fa-telegram-plane"},
                { network: "viber", icon: "fab fah fa-lg fa-viber"},
                { network: "sms", icon: "far fah fa-lg fa-comment-dots"}
            ],
        }
    },
    computed: {
        user() {
          return this.$store.state.auth.user;
        }
    },
    methods:{
        btnSfx(){
            this.$store.dispatch('sound/sfx','Button');
        },
        show() {
            this.$refs.shareModal.show();
        },
        hide() {
            this.$refs.shareModal.hide();
        },  
    },
})

export default SharePopup
</script>